import { React, useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from 'react-select';
import { fetchLocations, fetchCompartments } from "../../api/api";

function normalize(str) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^\w\s]/gi, '')        // Remove punctuation
    .replace(/\s+/g, ' ')            // Collapse whitespace
    .toLowerCase()
    .trim();
}

const softFilterOption = (option, inputValue) => {
  if (!inputValue) return true;
  const normLabel = normalize(option.label);
  const normInput = normalize(inputValue);
  return normLabel.includes(normInput);
};

const TransferModal = ({
    show,
    onHide,
    transferGroup,
    transferQuantity,
    setTransferQuantity,
    setTransferSquadronId,
    setTransferCompartmentId,
    confirmTransfer
}) => {
    const [sqadrons, setLocations] = useState([]);
    const [compartments, setCompartments] = useState([]);

    const [formData, setFormData] = useState({
        squad_id: '',
        product_id: '',
        compartment_id: '',
        nsn_size_id: '',
        quantity: '1'
      });

    const squadronOptions = sqadrons.map(squadron => ({
        value: squadron.id,
        label: squadron.name
    }));

    const compartmentOptions = compartments.map(compartment => ({
        value: compartment.id,
        label: compartment.name
    }));

    const handleSquadronChange = (selected) => {
        setTransferSquadronId(selected.value);
        setFormData({
        ...formData,
        squad_id: selected ? selected.value : ''
        });
        setFormData(fd => ({
        ...fd,
        compartment_id: ''
        }));
    };

    const handleCompartmentChange = (selected) => {
        setTransferCompartmentId(selected.value);
        setFormData({
        ...formData,
        compartment_id: selected ? selected.value : ''
        });
    };

    useEffect(() => {
        fetchLocations()
          .then(data => setLocations(data))
          .catch(error => console.error('Error fetching locations:', error));
      }, []);
    
    useEffect(() => {
        if (formData.squad_id) {
        fetchCompartments(formData.squad_id)
            .then(data => setCompartments(data))
            .catch(error => console.error('Error fetching compartments:', error));
        }
    }, [formData.squad_id]);

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Transfer Items</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>
                            How many items do you want to transfer? (Max:{" "}
                            {transferGroup?.quantity || 1})
                        </Form.Label>
                        <Form.Control type="number"
                            min={1}
                            max={transferGroup?.quantity || 1}
                            value={transferQuantity}
                            onChange={(e) =>
                                setTransferQuantity(
                                Math.max(
                                    1,
                                    Math.min(
                                    transferGroup?.quantity || 1,
                                    Number(e.target.value)
                                    )
                                )
                                )
                            } />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Squadron</Form.Label>
                        <Select
                        inputId="squad_id"
                        name="squad_id"
                        value={squadronOptions.find(opt => String(opt.value) === String(formData.squad_id)) || null}
                        onChange={handleSquadronChange}
                        options={squadronOptions}
                        placeholder="Select a squadron"
                        isClearable
                        classNamePrefix="react-select"
                        filterOption={softFilterOption}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                    <Form.Label>Compartment</Form.Label>
                        <Select
                        inputId="compartment_id"
                        name="compartment_id"
                        value={compartmentOptions.find(opt => String(opt.value) === String(formData.compartment_id)) || null}
                        onChange={handleCompartmentChange}
                        options={compartmentOptions}
                        placeholder="Select a compartment"
                        isClearable
                        classNamePrefix="react-select"
                        filterOption={softFilterOption}
                        />
                </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
                Cancel
            </Button>
            <Button variant="primary" onClick={confirmTransfer}>
                Transfer
            </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default TransferModal